import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {MatchParams} from '../../model/CustomModel';
import Counter from '../../test/Counter';
import InputSample from '../../test/InputSample';

const About =
    ({match} : RouteComponentProps<MatchParams>) => {
    return (
        <div className="bloc l-bloc" id="bloc-0">
            <h2>About {match.params.id}</h2>
            <Counter/>
            <InputSample />
        </div>
    );
};

export default About;
